module.exports = __webpack_public_path__ + "static/media/Team 29 - Rafiki.0626a898.png";